import { gql } from '@apollo/client';

export const REMOVE_VEHICLE = gql`
  mutation DeleteVehicle($input: DeleteVehicleInput) {
    deleteVehicle(input: $input) {
      id
    }
  }
`;
